import React from 'react';
import styled from 'styled-components';
import Link from 'next/link';

import { devices } from '@/styles/breakpoints';
export interface ISmallCardItem {
  slug: string;
  title: string;
  meta_description: string;
  mainImage?: { url: string } | null;
  time_to_read: string;
  formattedDate: string;
}

interface IProps {
  item: ISmallCardItem;
}

export const SmallCard = ({ item }: IProps) => {
  return (
    <Wrapper href={`/blog/${item.slug}`}>
      <ImageContent>
        <Overlay className="image" imageSrc={item?.mainImage?.url} />
      </ImageContent>
      <Content>
        <Title>{item.title}</Title>
        <Description>{item.meta_description}</Description>
        <Time>
          <span>{`${item.time_to_read} min read`}</span>
          <span>{item.formattedDate}</span>
        </Time>
      </Content>
    </Wrapper>
  );
};

const Wrapper = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

const ImageContent = styled.div``;

const Content = styled.div`
  width: 100%;
  height: auto;
  padding-right: 4px;
  @media only screen and ${devices.desktop} {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 8px;
  }
`;

const Overlay = styled.div<{ imageSrc: string }>`
  position: relative;
  width: 146px;
  height: 90px;
  border-radius: 10px;
  border: 1px solid #e6e8ec;
  background-size: cover;
  background-position: center;
  background-image: url(${(props) => props.imageSrc || '/default.jpg'});
  @media only screen and ${devices.desktop} {
    width: 264px;
    height: 164px;
  }
`;

const Title = styled.p`
  font-size: 18px;
  font-weight: 500;
  line-height: 28px;
`;

const Description = styled.p`
  font-size: 14px;
  color: #192d52;
  line-height: 20px;
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

const Time = styled.p`
  font-size: 14px;
  color: #4d4d4d;
  display: flex;
  justify-content: space-between;
`;
